import { RouteConfig } from 'vue-router';
import agreement from './modules/agreement';
import appDownload from './modules/app-download';
import taskCenter from './modules/task-center';
import supplementCert from './modules/supplement-cert';
import personalData from './modules/personal-data';
import healthDeclaration from './modules/health-declaration';
import epidemicProtocol from './modules/epidemic-protocol';
import license from './modules/license';
import member from './modules/member';
import writeOff from './modules/write-off';
import driverDsinfect from './modules/driver-disinfect';
import revenueFlow from './modules/revenue-flow';
import driverAudit from './modules/driver-audit';
import drivingBehavior from './modules/driving-behavior';
import depositRouter from './modules/deposit';
import siteCodeUpload from './modules/site-code-upload';

const routes: RouteConfig[] = [
  ...agreement,
  ...appDownload,
  ...taskCenter,
  ...supplementCert,
  ...personalData,
  ...healthDeclaration,
  ...epidemicProtocol,
  ...license,
  ...member,
  ...writeOff,
  ...driverDsinfect,
  ...driverAudit,
  ...revenueFlow,
  ...drivingBehavior,
  ...depositRouter,
  ...siteCodeUpload,
];

export default routes;
